/* eslint-disable prettier/prettier */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-param-reassign */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unsafe-optional-chaining */
import React, { memo, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Col, message, Row, Spin, Switch } from 'antd';
import { List, Scheduler } from 'devextreme-react';
import { AppointmentDragging, Resource } from 'devextreme-react/scheduler';
import moment from 'moment';
import { useLocation, useParams } from 'react-router-dom/dist';

import { CalendarOutlined, LoadingOutlined, UnorderedListOutlined } from '@ant-design/icons';

import Utils from '../../Assets/Scripts/Utils';
import CustomDropdown from '../../Components/CustomDropdown/CustomDropdown';
import ReasonModal from '../../Components/ReasonModal/ReasonModal';
import { readPortalResource } from '../../Components/ResourceFieldLayout/shouldRenderTaskField';
import Appointment from '../../Components/Schedule/Appointment';
import DataCell from '../../Components/Schedule/DataCell';
import DateCell from '../../Components/Schedule/DateCell';
import ListItem from '../../Components/Schedule/ListItem';
import OverviewPopup from '../../Components/Schedule/OverviewPopup';
import ResourceCellRender from '../../Components/Schedule/ResourceCellRender';
import ResumePopup from '../../Components/Schedule/ResumePopup';
import ScheduleUtils from '../../Components/Schedule/ScheduleUtils';
import { api } from '../../Services/axiosService';
import { loadAgendaFieldLayout } from '../Role/FieldCustomization/API/FieldCustomizationApi';
import { fetchProduct, fetchTaskStudents } from '../ScheduleConecta/API/ScheduleSchedulingAPI';
import SchedulingFunctions from '../ScheduleConecta/API/SchedulingFunctions';
import TaskDrawer from '../ScheduleConecta/Components/TaskDrawer';

import '../../Components/Schedule/ListItem.scss';
import '../../Components/Schedule/TasksList.scss';

let scheduleView = 'Dia';
let scheduleDate = moment(new Date()).format('YYYY-MM-DD');
let taskAcceptanceDeadline = 0;

let currentOpenTask = null;
let firstOpen = true;
let trainingOpened = false;

let timeout = null;
let currentListItem = null;
let filterCount = 0;
let filterCountNew = 0;

const views = [
  {
    name: 'Dia',
    type: 'day',
    cellDuration: 60,
  },
];
function ScheduleTrainingCenterComponent() {
  const draggingGroupName = 'appointmentsGroup';
  const groups = ['resourceId'];
  const schedulerRef = useRef(null);
  const overviewPopupRef = useRef(null);
  const resumePopupRef = useRef(null);
  const location = useLocation();
  const urlParams = useParams();

  const [loading, setLoading] = useState(false);
  const [loadingSchedule, setLoadingSchedule] = useState(false);
  const [currentView, setCurrentView] = useState('Dia');
  const [currentDate, setCurrentDate] = useState(new Date());
  const [appointments, setAppointments] = useState([]);
  const [trainingCenter, setTrainingCenter] = useState();
  const [blockedDates, setBlockedDates] = useState([]);
  const [slots, setSlots] = useState([]);
  const [fieldsPermissions, setFieldsPermissions] = useState();
  const [agendaResourceId, setAgendaResourceId] = useState();
  const [agendaResourceName, setAgendaResourceName] = useState();
  const [fieldLayout, setFieldLayout] = useState();
  const [roleId, setRoleId] = useState();
  const [instructorOptions, setInstructorOptions] = useState();
  const [driverOptions, setDriverOptions] = useState();
  const [trainingsOptions, setTrainingsOptions] = useState();
  const [stages, setStages] = useState();
  const [changeVisibility, setChangeVisibility] = useState(false);
  const [isReasonModalOpen, setReasonModalOpen] = useState(false);
  const [reasonEvent, setReasonEvent] = useState('');
  const [reasonOnOk, setReasonOnOk] = useState(null);
  const [reasonsOptions, setReasonsOptions] = useState();
  const [stagesValue, setStagesValue] = useState([3, 4, 5, 9, 10, 12, 13, 14, 15, 15]);
  const [stagesOptions, setStagesOptions] = useState();
  const [ctResources, setCtResources] = useState();
  const [ctResourcesSlots, setCtResourcesSlots] = useState();
  const [overview, setOverview] = useState([]);
  const [resume, setResume] = useState([]);
  const [reasonNoBillingOptions, setReasonNoBillingOptions] = useState([]);
  const [trainingCenterOptions, setTrainingCenterOptions] = useState([]);
  const [selectedTrainingCenterId, setSelectedTrainingCenterId] = useState();
  const [lastSelectedTrainingCenterId, setLastSelectedTrainingCenterId] = useState();
  const [isTaskDrawerVisible, setIsTaskDrawerVisible] = useState(false);
  const [currentTaskId, setCurrentTaskId] = useState(null);
  const [transportOptions, setTransportOptions] = useState([]);
  const [invoiceIssuersOptions, setInvoiceIssuersOptions] = useState([]);
  const [vehicleOptions, setVehicleOptions] = useState([]);
  const [isTaskReadOnly, setIsTaskReadOnly] = useState(false);
  const [settings, setSettings] = useState();

  // Certificado
  const [certificateModelOptions, setCertificateModelOptions] = useState([]);
  const [productOptions, setProductOptions] = useState([]);

  const denyTask = (task) => {
    const data = JSON.parse(JSON.stringify(task)); // Deep Copy da task
    const denyStage = stages?.find(({ id }) => id === 4);
    data.stage = denyStage;
    data.acceptanceDeadline = null;

    const handleDeny = async () => {
      setLoadingSchedule(true);

      await api
        .put('/Task/UpdateTaskStage', data)
        .then(() => {
          message.success('Treinamento Negado!');
        })
        .catch((error) => {
          Utils.logError(error);
          message.error('Oops. Algo deu errado ao negar o treinamento!');
        });

      setAppointments((prev) => {
        const mapped = prev.map((appt) => (appt.id === data.id ? { ...appt, ...data } : appt));
        return mapped.map((appt, index) => ({ ...appt, index }));
      });
      setLoadingSchedule(false);
    };

    setReasonEvent('TaskDenied');
    currentOpenTask = data;
    setReasonOnOk(() => handleDeny);
    setReasonModalOpen(true);
  };

  const onAppointmentDblClick = (e) => {
    e.cancel = true;

    const appointmentId = ScheduleUtils.readClickedAppointmentId(e);
    if (appointmentId == null) {
      return;
    }

    setCurrentTaskId(appointmentId);
    setIsTaskDrawerVisible(true);
  };

  const fetchTransportCompanies = async () => {
    try {
      const response = await api.get(
        '/Transport?filters[0].Field=CompanyType&filters[0].Condition=IN&filters[0].Value=Transporte&filters[1].Field=Status&filters[1].Condition=DIFFERENT&filters[1].Value=Inativo'
      );

      const responseMapped = response.data.map((tc) => ({
        ...tc,
        value: tc.id,
        label: tc.commercialName,
      }));
      setTransportOptions(responseMapped);
    } catch (error) {
      Utils.logError(error);
      message.error('Oops. Algo deu errado ao tentar buscar as Empresas de Transporte!');
    }
  };

  const fetchInvoiceIssuers = async () => {
    try {
      const response = await api.get(
        '/InvoiceIssuer?filters[0].Field=Status&filters[0].Condition=DIFFERENT&filters[0].Value=Inativo'
      );

      const responseMapped = response.data.map((invoiceIssuer) => ({
        ...invoiceIssuer,
        value: invoiceIssuer.id,
        label: `${invoiceIssuer.name} - ${invoiceIssuer.cnpj}`,
      }));
      setInvoiceIssuersOptions(responseMapped);
    } catch (error) {
      Utils.logError(error);
      message.error('Oops. Algo deu errado ao tentar buscar as Emissores de Nota Fiscal!');
    }
  };

  const fetchVehicles = () =>
    api
      .get(
        '/Vehicle?filters[0].Field=Status&filters[0].Condition=DIFFERENT&filters[0].Value=Inativo'
      )
      .then((res) => {
        const mappedOptions = res.data.map((item) => ({
          ...item,
          label: `${item.licensePlate} - ${item.type.name} (${item.capacity} pessoas)`,
        }));

        setVehicleOptions(mappedOptions);
      })
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar Veículos!');
      });

  const onListItemClick = (e) => {
    const data = e.itemData;
    if (!timeout) {
      timeout = setTimeout(() => {
        timeout = null;
      }, 300);
    } else if (data.id === currentListItem) {
      schedulerRef.current.instance.showAppointmentPopup(data);
    }
    currentListItem = data.id;
  };

  const filterAppointments = (filter) => {
    const stagesOptions = filter?.component?.option('selectedItems')?.map(({ value }) => value);
    filterCountNew += 1;
    setStagesValue(stagesOptions);
  };

  const onCurrentViewChange = (value) => {
    localStorage.setItem('conecta__currentView', value);
    setCurrentView(value);
  };

  const onCurrentDateChange = (value) => {
    localStorage.setItem('conecta__currentDate', value);
    setCurrentDate(value);
  };

  const renderDataCell = (itemData) => (
    <DataCell
      itemData={itemData}
      workDays={trainingCenter?.workDays}
      blockedDates={blockedDates}
      ctResourcesSlots={ctResourcesSlots}
      appointments={appointments.filter(({ stage: { id } }) => stagesValue?.includes(id))}
      showResourceCapacity
    />
  );

  const renderDateCell = (itemData) => (
    <DateCell itemData={itemData} workDays={trainingCenter?.workDays} blockedDates={blockedDates} />
  );

  const resourceCellRender = (itemData) => (
    <ResourceCellRender itemData={itemData} trainings={trainingsOptions} />
  );

  const appointmentRender = (itemData) => <Appointment itemData={itemData} type="trainingCenter" />;

  const renderAppointmentTooltip = (itemData) => {
    const appointmentData = ScheduleUtils.readTooltipAppointmentRecord(itemData);
    return <Appointment itemData={{ data: { appointmentData } }} />;
  };

  const renderItem = (itemData) => (
    <ListItem itemData={itemData} denyTask={denyTask} loading={loadingSchedule} />
  );

  const fetchQuotes = async (dealIds) => {
    const quoteFilter = `?filters[0].Field=DealId&filters[0].Condition=NUMBER.IN&filters[0].Value=${dealIds}`;

    return api
      .get(`/Quote${dealIds ? quoteFilter : ''}`)
      .then((res) => res.data)
      .catch((error) => {
        setLoading(false);
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os Negócios!');
      });
  };

  const fetchSlots = async () => {
    const scheduleData = JSON.parse(localStorage.getItem('conecta__scheduleData'));
    const userData = JSON.parse(localStorage.getItem('conecta__userData'));
    const ctId = parseInt(scheduleData?.trainingCenterId ?? userData?.companyId, 10);

    const slotsToFunction = await api
      .get(
        `/Slot?filters[0].Field=TrainingCenterId&filters[0].Condition=NUMBER.EQUAL&filters[0].Value=${ctId}`
      )
      .then((res) => res.data)
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao tentar buscar os Slots!');
      });

    const mappedSlots = slotsToFunction.map((slot) => ({ key: slot.id, ...slot }));
    setSlots(mappedSlots);
    return slotsToFunction;
  };

  const callSlotGeneration = (ct, readyDate, startDate, endDate, slotsToFunction) => {
    const storageCurrentDate = localStorage.getItem('conecta__currentDate');
    const dateKeyDate = readyDate ?? storageCurrentDate ? new Date(storageCurrentDate) : new Date();
    const dateKey = moment(dateKeyDate).format('YYYY-MM-DD');
    let filterStartDate = moment(dateKeyDate).format('YYYY-MM-DDTHH:mm:ss');
    let filterEndDate = null;

    if (startDate && endDate) {
      filterStartDate = moment(startDate.setHours(0, 0, 0, 1)).format('YYYY-MM-DDTHH:mm:ss');
      filterEndDate = moment(endDate.setHours(23, 59, 59, 99)).format('YYYY-MM-DDTHH:mm:ss');
    }

    // Inicio do calculo de horas de cada Slot das Pistas
    const resources = {};
    const resourcesSlots = {};
    SchedulingFunctions.calculateResourceSlots(
      resources,
      ct ?? trainingCenter,
      slotsToFunction,
      filterStartDate,
      filterEndDate
    );
    SchedulingFunctions.generateResourceSlots(resources, resourcesSlots);
    setCtResourcesSlots(resourcesSlots);
    setCtResources(resources[dateKey]);
  };

  const getProductName = (product) => {
    const customProductList = ScheduleUtils.getCustomProductList();
    const isCustomProduct = customProductList.includes(product?.id);

    if (isCustomProduct) {
      return product.complement ? product.complement : product.name;
    }

    return Utils.getProductNameComplement(product);
  };

  const fetchTasks = async (ct, startDate, endDate) => {
    try {
      let filterStartDate = null;
      let filterEndDate = null;

      if (!startDate || !endDate) {
        filterStartDate = moment(new Date().setHours(0, 0, 0, 1)).format('YYYY-MM-DDTHH:mm:ss');
        filterEndDate = moment(new Date().setHours(23, 59, 59, 999)).format('YYYY-MM-DDTHH:mm:ss');
      } else {
        filterStartDate = moment(startDate.setHours(0, 0, 0, 1)).format('YYYY-MM-DDTHH:mm:ss');
        filterEndDate = moment(endDate.setHours(23, 59, 59, 999)).format('YYYY-MM-DDTHH:mm:ss');
      }

      const tasks = await api
        .get(
          `/Task?filters[0].Field=TrainingCenterId&filters[0].Condition=NUMBER.EQUAL&filters[0].Value=${
            ct?.id ?? trainingCenter?.id
          }&filters[1].Field=StartDate&filters[1].Condition=DATE.>=&filters[1].Value=${filterStartDate}&filters[2].Field=StartDate&filters[2].Condition=DATE.<=&filters[2].Value=${filterEndDate}`
        )
        .then((res) => res.data);

      if (tasks?.length > 0) {
        const dealIds = tasks
          ?.filter(({ stage: { id } }) => stagesValue?.includes(id))
          .map(({ dealId }) => dealId)
          ?.toString();
        const quotesRes = await fetchQuotes(dealIds);
        const studentListRes = await fetchTaskStudents(tasks);

        const mappedTasks = tasks.map((task, index) => {
          const quote = quotesRes?.find(({ dealId }) => dealId === task.dealId);
          const queryStudentList = studentListRes
            ?.filter(({ taskId }) => taskId === task.id)
            .map((item) => ({ ...item, key: item.id }));

          const productName = getProductName(task.product);
          return {
            ...quote,
            ...task,
            text: productName,
            index,
            queryStudentList,
            notHaveCertificate: !!task.notHaveCertificate,
            productWithComplement: Utils.getProductNameComplement(task.product),
          };
        });

        SchedulingFunctions.getOverviewData(
          mappedTasks,
          setOverview,
          filterStartDate,
          filterEndDate
        );

        SchedulingFunctions.getResumeData(mappedTasks, setResume, filterStartDate, filterEndDate);

        setAppointments(mappedTasks);
      } else {
        setAppointments([]);
      }
    } catch (error) {
      Utils.logError(error);
      message.error('Oops. Algo deu errado ao buscar os treinamentos!');
    }
  };

  const fetchTrainingCenter = async () => {
    const isDev = process.env.NODE_ENV === 'development';
    try {
      setLoading(true);
      const ctId = parseInt(JSON.parse(localStorage.getItem('conecta__userData'))?.companyId, 10);
      const userId = parseInt(JSON.parse(localStorage.getItem('conecta__userData'))?.id, 10);

      // companyId costuma coincidir com o Id do CT (herança Company), mas em dev o GET pode falhar — não derruba o fluxo inteiro.
      let trainingCenterByCompanyId = null;
      if (!Number.isNaN(ctId) && ctId > 0) {
        try {
          trainingCenterByCompanyId = (await api.get(`/TrainingCenter?id=${ctId}`)).data;
        } catch (firstGetErr) {
          Utils.logError(firstGetErr);
          if (!isDev) throw firstGetErr;
        }
      }

      const response = (await api.get(`/TrainingCenter/UserTrainingCenters?id=${userId}`)).data;

      const hasSlots = (tc) =>
        (tc.ctQtySlots ?? 0) > 0 ||
        (tc.inCompanyQtySlots ?? 0) > 0 ||
        (tc.eadQtySlots ?? 0) > 0 ||
        (tc.serviceQtySlots ?? 0) > 0;

      let filteredAndSortedTrainingCenters = response
        .filter(hasSlots)
        .sort((a, b) => (b.ctQtySlots ?? 0) - (a.ctQtySlots ?? 0));

      // Dev: CTs sem slots configurados ainda não esvaziam a lista (permite abrir a agenda para configurar/testar).
      if (isDev && filteredAndSortedTrainingCenters.length === 0 && response?.length > 0) {
        filteredAndSortedTrainingCenters = [...response].sort(
          (a, b) => (b.ctQtySlots ?? 0) - (a.ctQtySlots ?? 0)
        );
      }

      setTrainingCenterOptions(filteredAndSortedTrainingCenters);

      let centerForAgenda = trainingCenterByCompanyId;

      if (filteredAndSortedTrainingCenters.length > 0) {
        const activeCenter =
          filteredAndSortedTrainingCenters.find((tc) => tc.id === ctId) ||
          filteredAndSortedTrainingCenters[0];
        setSelectedTrainingCenterId(activeCenter.id);
        setTrainingCenter(activeCenter);
        centerForAgenda = activeCenter;
      } else if (isDev && trainingCenterByCompanyId) {
        setSelectedTrainingCenterId(trainingCenterByCompanyId.id);
        setTrainingCenter(trainingCenterByCompanyId);
        centerForAgenda = trainingCenterByCompanyId;
      } else if (isDev && response?.length === 1) {
        const only = response[0];
        setSelectedTrainingCenterId(only.id);
        setTrainingCenter(only);
        centerForAgenda = only;
      }

      if (!centerForAgenda) {
        message.error(
          isDev
            ? '[Dev] Nenhum centro de treinamento disponível para este usuário. Verifique UserTrainingCenters e cadastro.'
            : 'Oops. Algo deu errado ao buscar os dados do centro de treinamento!'
        );
        return;
      }

      const slotsToFunction = await fetchSlots(centerForAgenda);
      callSlotGeneration(centerForAgenda, null, null, null, slotsToFunction);
      await fetchTasks(centerForAgenda);
    } catch (error) {
      Utils.logError(error);
      message.error('Oops. Algo deu errado ao buscar os dados do centro de treinamento!');
    } finally {
      setLoading(false);
    }
  };

  const fetchInstructors = async () => {
    try {
      const ctId = parseInt(JSON.parse(localStorage.getItem('conecta__userData'))?.companyId, 10);

      const filter = `/Instructor?filters[0].Field=CompanyType&filters[0].Condition=EQUAL&filters[0].Value=Instrutor&filters[1].Value=${ctId}&filters[1].Condition=NUMBER.ARRAY_CONTAIN&filters[1].Field=WorkTrainingCenters&filters[2].Field=Status&filters[2].Condition=DIFFERENT&filters[2].Value=Inativo`;
      const companyInstructors = await api.get(filter).then((res) => res.data);

      const chunkSize = 30;
      let instructors = [];

      for (let i = 0; i < companyInstructors?.length; i += chunkSize) {
        const chunkInstructors = companyInstructors?.slice(i, i + chunkSize);
        const instructorIds = chunkInstructors.map(({ id }) => id).toString();
        const userFilter = `/User?filters[0].Field=Company.Id&filters[0].Condition=NUMBER.IN&filters[0].Value=${instructorIds}&filters[1].Field=Status&filters[1].Condition=DIFFERENT&filters[1].Value=Inativo`;

        const chunkInstructorOptions = await api.get(userFilter).then((res) => res.data);
        instructors = [...instructors, ...chunkInstructorOptions];
      }

      setInstructorOptions(instructors);
    } catch (error) {
      Utils.logError(error);
      message.error('Oops. Algo deu errado ao buscar os Instrutores!');
    }
  };

  const fetchDrivers = () =>
    api
      .get(
        '/User?filters[0].Field=Company.CompanyType&filters[0].Condition=EQUAL&filters[0].Value=Motorista'
      )
      .then((res) => setDriverOptions(res.data))
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os Motoristas!');
      });

  const fetchBlockedDays = (pCtId) => {
    const filterCtId =
      pCtId ??
      trainingCenter?.id ??
      parseInt(JSON.parse(localStorage.getItem('conecta__userData'))?.companyId, 10);

    return api
      .get(
        `/BlockedDay?filters[0].Field=TrainingCenterId&filters[0].Condition=NUMBER.EQUAL&filters[0].Value=${filterCtId}`
      )
      .then((res) => setBlockedDates(res.data))
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os Dias Bloqueados do CT!');
      });
  };

  const fetchTrainings = () =>
    api
      .get('/Trainings')
      .then((res) => setTrainingsOptions(res.data))
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os Grupos de Treinamento!');
      });

  const fetchStages = async () => {
    await api
      .get(`/Stage`)
      .then((res) => setStages(res.data))
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os Estágios!');
      });

    const stages = await api
      .get(
        `/Stage?filters[0].Field=Id&filters[0].Condition=NUMBER.IN&filters[0].Value=3,4,5,9,10,12,13,14,15,16`
      )
      .then((res) => res.data)
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os Estágios filtrados!');
      });

    const mappedStages = stages?.map(({ id: value, name: label }) => ({
      label,
      value,
    }));

    setStagesValue(mappedStages?.map(({ value }) => value));
    setStagesOptions(mappedStages);

    return mappedStages?.map(({ value }) => value);
  };

  const fetchReasons = async () => {
    const reasons = await api
      .get(
        `/DenyTaskReason?filters[0].Field=Type&filters[0].Condition=IN&filters[0].Value=CT,NoBilling&filters[1].Field=Status&filters[1].Condition=DIFFERENT&filters[1].Value=Inativo`
      )
      .then((res) => res.data)
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os Motivos de descarte!');
      });

    setReasonsOptions(
      reasons?.map(({ id, name, type }) => ({
        label: name,
        value: id,
        type,
      }))
    );

    setReasonNoBillingOptions(
      reasons
        ?.filter(({ type }) => type === 'NoBilling')
        .map(({ id, name, type }) => ({
          label: name,
          value: id,
          type,
        }))
    );
  };

  const fetchTaskAcceptanceDeadline = () =>
    api
      .get(`/Settings?id=1`)
      .then((res) => {
        const decryptedResponse = Utils.decryptSettings(res.data);

        taskAcceptanceDeadline = decryptedResponse.taskAcceptanceDeadline;
        setCertificateModelOptions(decryptedResponse.certificateModelList ?? []);
        setSettings(decryptedResponse);
      })
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar as configurações!');
      });

  const getCurrentDate = () => scheduleDate;

  const handleTrainingCenterChange = async (value) => {
    try {
      // Encontrar o centro de treinamento na lista de opções.
      const selectedTrainingCenter = trainingCenterOptions.find((tc) => tc.id === value);
      if (!selectedTrainingCenter) {
        message.error('Centro de treinamento não encontrado.');
        return;
      }

      // Atualizar o estado com o novo centro de treinamento.
      setSelectedTrainingCenterId(value);
      setTrainingCenter(selectedTrainingCenter);

      // Atualizar os dados no localStorage se necessário.
      const scheduleData = {
        ...JSON.parse(localStorage.getItem('conecta__scheduleData') || '{}'),
        trainingCenterId: selectedTrainingCenter.id,
        trainingCenter: selectedTrainingCenter.commercialName,
        maxCapacityPerDay: selectedTrainingCenter.maxCapacityPerDay,
      };
      localStorage.setItem('conecta__scheduleData', JSON.stringify(scheduleData));

      // Refazer buscas e cálculos relacionados ao novo centro.
      const slots = await fetchSlots(selectedTrainingCenter);
      callSlotGeneration(selectedTrainingCenter, null, null, null, slots);

      const currentStartDate = schedulerRef?.current?.instance?.getStartViewDate();
      const currentEndDate = schedulerRef?.current?.instance?.getEndViewDate();

      await fetchTasks(selectedTrainingCenter, currentStartDate, currentEndDate);
      await fetchBlockedDays(selectedTrainingCenter.id);
      fetchInstructors(); // Atualiza instrutores se eles estiverem ligados ao centro.

      // Re-renderiza o formulário ou componentes relacionados se necessário.
    } catch (error) {
      message.error('Erro ao processar a mudança de centro de treinamento.');
      message.error(error);
    }
  };

  const fetchData = async () => {
    try {
      const [product] = await Promise.all([fetchProduct()]);

      setProductOptions(product);
    } catch (error) {
      Utils.logError(error);
      message.error('Oops. Algo deu errado ao tentar buscar as opções de filtro!');
    }
  };

  const onContentReady = async (e) => {
    const { component } = e;
    const view = component.option('currentView');
    const date = moment(component.option('currentDate')).format('YYYY-MM-DD');

    const currentViewChanged = view !== scheduleView;
    const currentDateChanged = date !== scheduleDate;
    const filterChanged = filterCount !== filterCountNew;

    filterCount = filterCountNew;
    scheduleView = view;
    scheduleDate = date;

    let toolbar = component.option('toolbar');
    toolbar = [
      {
        location: 'before',
        defaultElement: 'dateNavigator',
      },
      {
        location: 'after',
        widget: 'dxButton',
        options: {
          text: 'Resumo',
          onClick: () => {
            resumePopupRef.current.instance.show();
          },
        },
      },
      {
        location: 'after',
        widget: 'dxButton',
        options: {
          text: 'Overview',
          onClick: () => {
            overviewPopupRef.current.instance.show();
          },
        },
      },
      {
        location: 'before',
        widget: 'dxTagBox',
        options: {
          displayExpr: 'label',
          keyExpr: 'value',
          width: 300,
          items: stagesOptions,
          maxDisplayedTags: 1,
          value: stagesValue,
          valueExpr: 'value',
          showSelectionControls: true,
          onFocusOut: (filter) => filterAppointments(filter),
        },
      },
      {
        location: 'before',
        widget: 'dxSelectBox',
        key: selectedTrainingCenterId,
        options: {
          displayExpr: 'commercialName',
          keyExpr: 'id',
          width: 300,
          dataSource: trainingCenterOptions,
          valueExpr: 'id',
          value: selectedTrainingCenterId,
          onValueChanged: ({ value }) => handleTrainingCenterChange(value),
        },
      },
    ];

    if (firstOpen === true && appointments.length > 0) {
      firstOpen = false;
      component.option('toolbar', toolbar);
    }

    if (
      currentViewChanged ||
      currentDateChanged ||
      filterChanged ||
      selectedTrainingCenterId !== lastSelectedTrainingCenterId
    ) {
      component.option('toolbar', toolbar);
      setLastSelectedTrainingCenterId(selectedTrainingCenterId);
    }

    if (currentViewChanged || currentDateChanged) {
      fetchTasks(trainingCenter, component.getStartViewDate(), component.getEndViewDate());
      callSlotGeneration(
        trainingCenter,
        date,
        component.getStartViewDate(),
        component.getEndViewDate(),
        slots
      );
    }

    if (trainingOpened === false && urlParams?.action === 'OpenTraining') {
      trainingOpened = true;
      const tasks = await api
        .get(
          `/Task?filters[0].Field=Id&filters[0].Condition=NUMBER.EQUAL&filters[0].Value=${parseInt(
            urlParams.taskId,
            10
          )}`
        )
        .then((res) => res.data);

      if (tasks?.length > 0) {
        const [task] = tasks;
        const [quote] = await fetchQuotes(task.dealId.toString());

        const taskMapped = { ...quote, ...task };
        component.showAppointmentPopup(taskMapped);
      }
    }
  };

  useLayoutEffect(() => {
    const permissions = {};
    JSON.parse(localStorage.getItem('conecta__permissions'))?.resources.forEach(
      ({ name, fields }) => {
        if (name === 'ScheduleTrainingCenter') {
          fields.forEach(({ name, access, isRequired, isADM }) => {
            permissions[name] = { access, isRequired, isADM };
          });
        }
      }
    );

    setFieldsPermissions(permissions);
    const portalResource = readPortalResource('ScheduleTrainingCenter');
    setAgendaResourceId(portalResource.resourceId);
    setAgendaResourceName(portalResource.resourceName);
    setRoleId(JSON.parse(localStorage.getItem('conecta__permissions'))?.id);
    loadAgendaFieldLayout(portalResource.resourceId).then(setFieldLayout);
    fetchTrainingCenter();
    fetchBlockedDays();
  }, []);

  useEffect(() => {
    fetchData();
    fetchTaskAcceptanceDeadline();
    fetchInstructors();
    fetchDrivers();
    fetchTrainings();
    fetchStages();
    fetchReasons();
    fetchTransportCompanies();
    fetchVehicles();
    fetchInvoiceIssuers();
  }, []);

  // Reseta o carregamento da tela quando o usuário sai da tela
  useEffect(
    () => () => {
      firstOpen = true;
    },
    [location]
  );

  if (loading || !ctResources || !ctResourcesSlots) {
    return (
      <Row gutter={[24]}>
        <Col
          span={24}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '72vh',
          }}
        >
          <Spin
            indicator={
              <LoadingOutlined
                style={{
                  fontSize: 56,
                  textAlign: 'center',
                }}
                spin
              />
            }
          />
        </Col>
      </Row>
    );
  }

  if (!loading && ctResources && ctResourcesSlots) {
    return (
      <Row gutter={[12]}>
        <Col span={24}>
          <div className="changeVisibility">
            <Switch
              checkedChildren={<CalendarOutlined />}
              unCheckedChildren={<UnorderedListOutlined />}
              defaultChecked
              onClick={() => {
                setChangeVisibility(!changeVisibility);
              }}
            />
          </div>

          <List
            id="tasks-list"
            style={{ marginTop: 35 }}
            visible={changeVisibility}
            dataSource={appointments}
            height="calc(100vh - 90px)"
            searchExpr={['text', 'classId', 'quoteTitle', 'stage.name', 'startDate']}
            searchEnabled={true}
            itemRender={renderItem}
            onItemClick={onListItemClick}
          />

          {trainingCenter?.id && (
            <CustomDropdown
              type="TrainingCenter"
              sourceId={trainingCenter?.id}
              updateBlockedDays={fetchBlockedDays}
              workDays={trainingCenter?.workDays}
              breakTime={{
                breakStart: trainingCenter?.breakStart,
                breakFinish: trainingCenter?.breakFinish,
              }}
              blockedDates={blockedDates}
              dataSource={appointments}
              visible={changeVisibility}
            />
          )}

          <OverviewPopup
            overviewPopupRef={overviewPopupRef}
            overviewList={overview}
            totalStudents={trainingCenter?.maxCapacityPerDay}
            getCurrentDate={getCurrentDate}
          />

          <ResumePopup
            resumePopupRef={resumePopupRef}
            resumeList={resume}
            getCurrentDate={getCurrentDate}
            schedulerRef={schedulerRef}
            ctName={trainingCenter?.name}
          />

          <Scheduler
            style={
              !changeVisibility
                ? null
                : {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    height: 0,
                    width: 0,
                    visibility: 'hidden',
                  }
            }
            ref={schedulerRef}
            disabled={loadingSchedule}
            id="scheduleTrainingCenter"
            views={views}
            groups={groups}
            groupByDate
            dataSource={ScheduleUtils.sortAppointmentsBySlotEnqueueOrder(
              appointments.filter(({ stage: { id } }) => stagesValue?.includes(id))
            )}
            defaultCurrentView={
              localStorage.getItem('conecta__currentView')
                ? localStorage.getItem('conecta__currentView')
                : currentView
            }
            defaultCurrentDate={
              localStorage.getItem('conecta__currentDate')
                ? new Date(localStorage.getItem('conecta__currentDate'))
                : currentDate
            }
            startDayHour={8}
            endDayHour={18}
            showAllDayPanel={false}
            firstDayOfWeek={1}
            maxAppointmentsPerCell={1}
            dataCellRender={renderDataCell}
            dateCellRender={renderDateCell}
            resourceCellRender={resourceCellRender}
            onCurrentViewChange={onCurrentViewChange}
            onCurrentDateChange={onCurrentDateChange}
            onAppointmentDblClick={onAppointmentDblClick}
            onAppointmentFormOpening={onAppointmentDblClick}
            appointmentComponent={appointmentRender}
            appointmentTooltipRender={renderAppointmentTooltip}
            appointmentTooltipKeyFn={ScheduleUtils.readAppointmentTooltipKey}
            onContentReady={onContentReady}
            crossScrollingEnabled
            showCurrentTimeIndicator={false}
            editing={{
              allowResizing: false,
              allowDeleting: false,
            }}
            onCellClick={(e) => {
              e.cancel = true;
            }}
          >
            <AppointmentDragging
              group={draggingGroupName}
              onDragStart={(e) => {
                e.cancel = true;
              }}
            />
            <Resource
              fieldExpr="resourceId"
              allowMultiple={false}
              dataSource={ctResources}
              label="Recurso"
            />
          </Scheduler>
        </Col>

        {isReasonModalOpen && (
          <ReasonModal
            setModalOpen={setReasonModalOpen}
            reasonsOptions={reasonsOptions}
            currentOpenTask={currentOpenTask}
            event={reasonEvent}
            eventSource="CT"
            onOk={reasonOnOk}
          />
        )}

        {isTaskDrawerVisible && (
          <TaskDrawer
            taskId={currentTaskId}
            fieldsPermissions={fieldsPermissions}
            stages={stages}
            instructorOptions={instructorOptions}
            trainingsOptions={trainingsOptions}
            ctResources={ctResources}
            transportOptions={transportOptions}
            reasonNoBillingOptions={reasonNoBillingOptions}
            invoiceIssuersOptions={invoiceIssuersOptions}
            vehicleOptions={vehicleOptions}
            driverOptions={driverOptions}
            productOptions={productOptions}
            certificateModelOptions={certificateModelOptions}
            setIsTaskDrawerVisible={setIsTaskDrawerVisible}
            taskAcceptanceDeadline={taskAcceptanceDeadline}
            ctResourcesSlots={ctResourcesSlots}
            setAppointments={setAppointments}
            appointments={appointments}
            isTaskReadOnly={isTaskReadOnly}
            setIsTaskReadOnly={setIsTaskReadOnly}
            page="ScheduleTrainingCenter"
            settings={settings}
            resourceId={agendaResourceId}
            resourceName={agendaResourceName}
            fieldLayout={fieldLayout}
            roleId={roleId}
          />
        )}
      </Row>
    );
  }
}

const ScheduleTrainingCenter = memo(ScheduleTrainingCenterComponent);
export default ScheduleTrainingCenter;
